<template>
  <v-card outlined class="pa-0 ma-0 rounded-lg">
    <v-card-title>{{ bezMitglieder }} suchen</v-card-title>
    <v-card-text class="pa-0">
      <v-autocomplete outlined dense class="mx-4" label="Suchen..." @change="selectBbr()" :items="selectBundesbruder" v-model="bundesbruder"></v-autocomplete>
      <div v-if="bundesbruder">
        <dialogKontakt :visible.sync="showBbr" :bbr="bbr" @close="showBbr = false"></dialogKontakt>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {
    data () {
      return {
        bundesbruder: '',
        bbr: [],
        showBbr: false
      }
    },
    computed: {
      bezMitglieder () {
        return this.$store.state.einstellungen.einstellungen.find(item => item.id === 'allgemein').bezMitglieder1
      },
      selectBundesbruder () {
        const items = this.$store.getters['bbrbbr/nurBbrbbr']
        return items.map(item => ({
          value: item.id,
          text: `${item.nachname}, ${item.vorname}${item.vulgo ? ` (${item.vulgo})` : ''}`
        }))
      }
    },
    methods: {
      selectBbr () {
        this.bbr = this.$store.getters['bbrbbr/bbr'](this.bundesbruder)
        this.showBbr = true
      }
    }
  }
</script>



// WEBPACK FOOTER //
// bundesbruderSuche.vue?20c0b224